import React, { useContext } from "react";
import MyContext from "../../../StoreContext";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const deriveContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "220px",
  background: "#F6FBFE",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "15px",
  padding: "16px",
};

const deriveTitle = {
  fontSize: "18px",
  fontWeight: "600",
  fontFamily: "Asap",
  color: "#000000",
  lineHeight: "20px",
};

const deriveStyle = {
  fontSize: "14px",
  fontWeight: "500",
  fontFamily: "Asap",
  color: "#000000",
  textAlign: "left",
  marginTop: "8px",
};

/**
 * Componente que muestra cuando una respuesta debe ser derivada
 */
const Derive = () => {
  const { message } = useContext(MyContext);

  return (
    <Grid sx={deriveContainer}>
      <Typography sx={deriveTitle}>Distribución:</Typography>
      <Typography sx={deriveStyle}>
        {message === "stolen" || message === "order" || message === "consult"
          ? "Derivado a equipo de Atención prioritaria a clientes"
          : "N/A"}
      </Typography>
    </Grid>
  );
};

export default Derive;
